import { useAppSelector } from '@energy-stacks/fleet/store';
import { useCallback } from 'react';

export const useRemovePlantIdPrefix = () => {
  const selectedPlantId = useAppSelector(
    (state) => state.plant.selectedPlantId
  );

  return useCallback(
    (stringToTransform: string | undefined): string => {
      if (!stringToTransform) {
        return '';
      }

      const plantIdPrefix = `${selectedPlantId} - `;
      if (!selectedPlantId || !stringToTransform.includes(plantIdPrefix)) {
        return stringToTransform;
      }

      return stringToTransform.replace(plantIdPrefix, '');
    },
    [selectedPlantId]
  );
};
